import { Component } from '@angular/core';

@Component({
  selector: 'app-placeholder-connections',
  templateUrl: './placeholder-connections.component.html',
  styleUrls: ['./placeholder-connections.component.css']
})
export class PlaceholderConnectionsComponent {

}
